export const BetsReportingMessageChannels = {
    GetSettledBets: "GetSettledBets"
};
//# sourceMappingURL=index.js.map